module.exports = __webpack_public_path__ + "static/admin-settings-a15669e04b6e5e973b6242cbdd7ee7a5.jpg";